import {
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
} from "@fluentui/react-components";
import {
  ArrowDown12Regular,
  ArrowSortDown16Filled,
  ArrowSortUp16Filled,
} from "@fluentui/react-icons";
import { SortingDirection } from "models/enums/SortingOrder";
import { IColumnActionsMenuProps } from "./ColumnActionsMenu.types";

export const ColumnActionsMenu = (
  props: IColumnActionsMenuProps,
): JSX.Element => {
  const isAscending: boolean =
    props.sortingDirection === SortingDirection.Ascending;
  const isDescending: boolean =
    props.sortingDirection === SortingDirection.Descending;

  return (
    <Menu>
      <MenuTrigger>
        <MenuButton
          appearance="subtle"
          icon={
            isAscending ? (
              <ArrowSortUp16Filled />
            ) : isDescending ? (
              <ArrowSortDown16Filled />
            ) : (
              <ArrowDown12Regular />
            )
          }
        />
      </MenuTrigger>
      <MenuPopover>
        <MenuList>
          <MenuItem
            icon={<ArrowSortUp16Filled />}
            onClick={(): void => props.onSortClicked(props.columnKey, false)}
            disabled={isAscending || !props.isSortable}
          >
            Sort A to Z
          </MenuItem>
          <MenuItem
            icon={<ArrowSortDown16Filled />}
            onClick={(): void => props.onSortClicked(props.columnKey, true)}
            disabled={isDescending || !props.isSortable}
          >
            Sort Z to A
          </MenuItem>
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};
